import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

constructor(
   private authService:AuthService,
private router:Router,
private flashMessage: FlashMessagesService
) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts